import { render, staticRenderFns } from "./cancel.vue?vue&type=template&id=d02e0182&scoped=true&"
import script from "./cancel.vue?vue&type=script&lang=js&"
export * from "./cancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d02e0182",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d02e0182')) {
      api.createRecord('d02e0182', component.options)
    } else {
      api.reload('d02e0182', component.options)
    }
    module.hot.accept("./cancel.vue?vue&type=template&id=d02e0182&scoped=true&", function () {
      api.rerender('d02e0182', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/allocation_configs/actions/cancel.vue"
export default component.exports